var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRealEstateIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.041 30.125h-2.473V.937A.937.937 0 0026.63 0H5.168a.938.938 0 00-.938.938v29.187H1.756a.937.937 0 100 1.875H30.04a.937.937 0 100-1.875zm-17.338 0v-6.391h6.391v6.391h-6.391zm8.266 0v-7.329a.937.937 0 00-.937-.937h-8.267a.938.938 0 00-.937.937v7.329H6.104V1.875h19.589v28.25h-4.724z",
    fill: "#ADC6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.883 4.144H9.289a.938.938 0 00-.938.938v4.594c0 .518.42.938.938.938h4.594c.518 0 .937-.42.937-.938V5.082a.938.938 0 00-.937-.938zm-.938 4.595h-2.719v-2.72h2.72v2.72zM22.509 4.144h-4.595a.937.937 0 00-.937.938v4.594c0 .518.42.938.937.938h4.595c.517 0 .937-.42.937-.938V5.082a.937.937 0 00-.937-.938zM21.57 8.74h-2.72v-2.72h2.72v2.72zM13.883 12.872H9.289a.938.938 0 00-.938.938v4.594c0 .518.42.937.938.937h4.594c.518 0 .937-.42.937-.937V13.81a.938.938 0 00-.937-.938zm-.938 4.594h-2.719v-2.719h2.72v2.72zM22.509 12.872h-4.595a.938.938 0 00-.937.938v4.594c0 .518.42.937.937.937h4.595c.517 0 .937-.42.937-.937V13.81a.938.938 0 00-.937-.938zm-.938 4.594h-2.72v-2.719h2.72v2.72z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/real-estate-industry.d3e23d5b5dd8074d432859200c5191ed.svg";
export { SvgRealEstateIndustry as ReactComponent };